"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _OutsideElement = _interopRequireDefault(require("./OutsideElement"));
var _BrixelIcon = _interopRequireDefault(require("./BrixelIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelDropdown = props => {
  // PROPS
  const {
    alignmentDropList = 'left',
    bgTransparent = false,
    borderColor = 'text',
    className = '',
    closeDropDown = false,
    color = 'text',
    compact = false,
    envPath = '',
    keyType = 'label',
    liClass = '',
    noBorder = false,
    onSelect = null,
    options,
    saturationBrd = 400,
    saturationTxt = 700,
    selected = '',
    selectedComponent = null,
    selectedDetails = {},
    selectedLi = '',
    ulClass = ''
  } = props;
  // STATE
  const [dropdownOpen, setDropdownOpen] = (0, _react.useState)(false);
  // REF
  const wrapperRef = (0, _react.useRef)(null);
  const listItemRef = (0, _react.useRef)(null);
  const clickAction = (e, data) => {
    setDropdownOpen(false);
    if (onSelect) onSelect(e, data);
  };
  (0, _react.useEffect)(() => {
    if (closeDropDown) setDropdownOpen(false);
  }, [closeDropDown]);
  const classTransparent = bgTransparent ? 'bgTransparent' : '';
  const colorClass = `txt${color.charAt(0).toUpperCase()}${color.slice(1)}${saturationTxt > 0 ? saturationTxt : ''}`;
  const iconColorClass = `icn${color.charAt(0).toUpperCase()}${color.slice(1)}${saturationTxt > 0 ? saturationTxt : ''}`;
  const borderColorClass = `brd${borderColor.charAt(0).toUpperCase()}${borderColor.slice(1)}${saturationBrd > 0 ? saturationBrd : ''}`;
  const borderClass = noBorder ? '' : 'brdSmall';
  (0, _OutsideElement.default)(wrapperRef, {
    action: 'function',
    func: () => setDropdownOpen(false)
  });
  (0, _react.useEffect)(() => {
    const listItemsEl = listItemRef.current || {
      scrollIntoView: () => ''
    };
    if (listItemsEl.scrollIntoView) listItemsEl.scrollIntoView({
      block: 'nearest',
      behavior: 'smooth'
    });
  }, [dropdownOpen]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `dropdown ${compact ? 'compact' : ''} ${className} ${dropdownOpen ? 'open' : 'close'} ${classTransparent} ${borderColorClass} ${borderClass} brdRadius`,
    ref: wrapperRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `selElement ${colorClass} ${iconColorClass} ${selectedDetails ? 'dis-fl-col detailed' : 'dis-fl-row a-c'}`,
    onClick: () => setDropdownOpen(!dropdownOpen)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-fl-row w-perc-100 jc-b a-c"
  }, selectedComponent && (0, _get.default)(selectedComponent, 'component', null) ? (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(selectedComponent.component, selectedComponent.props), (0, _get.default)(selectedComponent, 'props.name', null) && (/*#__PURE__*/_react.default.createElement("span", {
    className: "ml-1 fsize-300 ws-nw"
  }, selectedComponent.props.name)))) : (/*#__PURE__*/_react.default.createElement("span", {
    className: "title",
    dangerouslySetInnerHTML: {
      __html: selected.toString()
    }
  })), /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    className: "ml-2",
    icon: dropdownOpen ? 'dropdown-open' : 'dropdown-close'
  })),
  // If it has stub it means it is the property dropdown
  // that needs the info below the title
  selectedDetails && Object.keys(selectedDetails).length > 0 && (/*#__PURE__*/_react.default.createElement("div", {
    className: "detail-container dis-fl-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bedrooms mr-1"
  }, /*#__PURE__*/_react.default.createElement("span", null, (0, _get.default)(selectedDetails, 'typology.bedrooms', '')), /*#__PURE__*/_react.default.createElement("span", null, " rooms")), /*#__PURE__*/_react.default.createElement("div", {
    className: "living-space mr-1"
  }, /*#__PURE__*/_react.default.createElement("span", null, (0, _get.default)(selectedDetails, 'typology.livingArea.value', '')), /*#__PURE__*/_react.default.createElement("span", null, " m2")), /*#__PURE__*/_react.default.createElement("div", {
    className: "construction"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Built in "), /*#__PURE__*/_react.default.createElement("span", null, (0, _get.default)(selectedDetails, 'building.built', '')))))), /*#__PURE__*/_react.default.createElement("ul", {
    ref: listItemRef,
    className: `shadow-4dp dropdown-list ${ulClass} ${alignmentDropList}`
  }, options.map((keys, i) => {
    const label = (0, _get.default)(keys, keyType, '');
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: `opt_${i.toString()}`
    }, (0, _get.default)(keys, 'component', null) && (0, _get.default)(keys, 'component.component', null) ? (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement((0, _get.default)(keys, 'component.component', ''), {
      ...(0, _get.default)(keys, 'component.params', {})
    }))) : (/*#__PURE__*/_react.default.createElement("li", {
      className: `${liClass} ${selectedLi === keys.id ? 'active' : ''}`,
      key: `drop_${i.toString()}`,
      onClick: e => (0, _get.default)(keys, 'component', null) ? '' : clickAction(e, keys)
    }, (0, _get.default)(keys, 'icon', null) && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
      className: "mr-1",
      icon: keys.icon || ''
    })), (0, _get.default)(keys, 'coverPhoto', null) && (/*#__PURE__*/_react.default.createElement("img", {
      className: "property-photo w-fix-96 h-fix-80",
      src: `${envPath}${(0, _get.default)(keys, 'coverPhoto.path', '')}`,
      alt: "Brixel Property",
      id: "cover-photo"
    })), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label))));
  })));
};
var _default = exports.default = BrixelDropdown;